import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { playSoundEffect } from '../hooks/useSoundEffects';
import { EXPLORE_UNKNOWN_REWRITE_EXPERIENCE_METER } from '../config/exploreUnknownRewriteExperience';
import '../BattleUIExploreUnknownDarknessFlash.css';

/**
 * @param {{
 *   popupId: string,
 *   partsCollected: number,
 *   targetParts: number,
 *   setCompleted: boolean,
 *   newCharges?: number,
 *   onDismiss: () => void,
 * }} props
 */
export default function ExploreUnknownRewriteFragmentMapProcModal({
  popupId,
  partsCollected,
  targetParts,
  setCompleted,
  newCharges,
  onDismiss,
}) {
  const { t } = useTranslation();

  useEffect(() => {
    playSoundEffect('/sounds/legendary_reveal.mp3');
  }, [popupId]);

  const bodyKey = setCompleted
    ? 'exploreUnknownBattle.rewriteFragmentMapProcSetCompleteBody'
    : 'exploreUnknownBattle.rewriteFragmentMapProcBody';

  return createPortal(
    <div className="battle-eu-heart-set-complete-overlay explore-unknown-reward-popup-overlay" onClick={onDismiss}>
      <div
        className="battle-eu-heart-set-complete-modal battle-eu-heart-set-complete-modal--rewrite explore-unknown-reward-popup-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="explore-unknown-rewrite-fragment-map-proc-title"
      >
        <h3 id="explore-unknown-rewrite-fragment-map-proc-title" className="battle-eu-heart-set-complete-title">
          {t('exploreUnknownBattle.rewriteFragmentMapProcTitle')}
        </h3>
        <div className="battle-eu-heart-set-complete-visual">
          <img
            src={EXPLORE_UNKNOWN_REWRITE_EXPERIENCE_METER.image}
            alt=""
            className="battle-eu-heart-set-complete-image"
          />
        </div>
        <p className="battle-eu-heart-set-complete-body">
          {t(bodyKey, {
            partsCollected,
            targetParts,
            charges: newCharges ?? 0,
          })}
        </p>
        <button type="button" className="battle-eu-heart-set-complete-ok" onClick={onDismiss}>
          {t('exploreUnknownBattle.rewriteFragmentMapProcOk')}
        </button>
      </div>
    </div>,
    document.body
  );
}
